import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import { useStore } from '../../../store/store-provider';
import { LiveStreamStatusComponent } from './live-stream-status';
import './live-stream-info.scss';
import { LiveStreamStatus } from '../../../constans/presenter-enums';

interface IProps {
  status: LiveStreamStatus;
}
const LiveStreamInfoComponent: FC<IProps> = ({ status }) => {
  const pageName = useLocation().pathname.split('/').pop();
  const { chatStore: { isVisible }, questionStore: { isMoreMenuOpen }} = useStore();

  return (
    <div
      className={`live-stream-info-container ${pageName == 'qanda' && 'status-qanda'} ${isVisible && 'status-for-chat'}`}
      style={{ display: isMoreMenuOpen ? 'none' : 'flex' } }
    >
      <LiveStreamStatusComponent status={status}/>
    </div>
  );
};

export default observer (LiveStreamInfoComponent);
